module.exports = __webpack_public_path__ + "img/louise-cannon.09645783.png";